import React, {useState, useEffect} from 'react';


export default function MediaQueryDisplay({query, excludes = false, children}) {

    const mediaQuery = window.matchMedia(query instanceof Array ? query.join(', ') : query);

    const [matches, setMatches] = useState(mediaQuery.matches);

    useEffect(() => {
        mediaQuery.addListener(() => {
            setMatches(mediaQuery.matches);
        });
    }, []);

    if (excludes && matches || !excludes && !matches) {
        return null;
    }

    return children;
}
